export enum UserRole {
  Interviewee = 1,
  Interviewer = 2, // Renamed from Expert to Interviewer
  // Keep string values for backward compatibility
  InterviewerString = 'interviewer', // Renamed from expert to interviewer
  IntervieweeString = 'interviewee'
}

export interface BaseUserProfile {
  id: string;
  email: string;
  profileName: string;
  mobile: string;
  country: string;
  profilePicture?: string;
  linkedinUrl: string;
  specialty: string;
  company: string;
  experience: string;
  languages: string[];
}

export interface InterviewerProfile extends BaseUserProfile {
  role: UserRole.Interviewer; // Renamed from Expert to Interviewer
  availableTimeSlots: TimeSlot[];
}

export interface IntervieweeProfile extends BaseUserProfile {
  role: UserRole.Interviewee;
  purpose: string;
}

export interface TimeSlot {
  id: string;
  startTime: Date;
  endTime: Date;
  isAvailable: boolean;
}

export type UserProfile = InterviewerProfile | IntervieweeProfile; 